import React, { useState } from "react";
import {
  Show,
  TabbedShowLayout,
  Tab,
  ReferenceField,
  BooleanField,
  DeleteButton,
  TextField,
  DateField,
  NumberField,
  ReferenceManyField,
  Datagrid,
  DatagridBody,
  TopToolbar,
  RefreshButton,
  ListButton,
  EditButton,
  Button,
  Link,
  List,
  ShowController,
  SimpleShowLayout,
  ShowView,
  useRecordContext,
  usePermissions,
  useResourceContext,
  useGetOne,
  useRedirect,
  ShowButton,
} from "react-admin";
import {
  AmountField,
  LineItemTotalField,
  ExpectedDateField,
  CamelCaseField,
  ConvQtyField,
  ConvQtyUomField,
  PaymentAmountField,
} from "./common";
// import { LineItemsSideComponent } from '../singleDeliveryOrders/common';
import CreateSDOButton from "./createSdoButton";
import { getLocalStorageKey, getCurrencySymbol } from "../common/common";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
// import AccessAlarmIcon from '@mui/icons-material/AccessAlarmIcon';

import CustomModal from "./CustomModal";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";

let DeliveryNumber = 0;
let RecordId = [];
const apiUrl = RUN_TIME_API_ENDPOINT;
let orderStatus = null;
let isSdoCreated = 0;

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const CreateUser = ({ data, basePath, resource }) => {
//   console.log("record", data, basePath, resource);
//   return (
//     <Button
//       className="custom-button"
//       component={Link}
//       to={{
//         pathname: `/users/create`,
//         business_id: data && data.business_id,
//       }}
//     >
//       <span>Create User</span>
//     </Button>
//   );
// };

const ShowActions = (props) => {
  // const digitalOrderStatusKeyMappings = getLocalStorageKey('order_status_key_mappings');
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     openModal: false,
  //     openMessageModal: false,
  //     isResendBtnDisable: false,
  //     openPaymentModal: false,
  //     openPaymentMessageModal: false,
  //   };
  // }
  const record = useRecordContext();
  const location = useLocation();
  const redirect = useRedirect();

  const [openModal, setOpenModal] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [isResendBtnDisable, setIsResendBtnDisable] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openPaymentMessageModal, setOpenPaymentMessageModal] = useState(false);
  const [openOrderSendModal, setOpenOrderSendModal] = useState(false);
  const [openOrderSendMsgModal, setOpenOrderSendMsgModal] = useState(false);

  // open modal function
  const onOpenModal = () => {
    console.log("umesh ==>");
    // this.setState({ openModal: true });
    setOpenModal(true);
  };

  const onCloseModal = () => {
    // this.setState({ openModal: false });
    setOpenModal(false);
  };

  const onOkModal = (data) => {
    console.log("data 123 ===>", data);
    // this.setState({ openModal: false, openMessageModal: true });
    setOpenModal(false);
    setOpenMessageModal(true);

    // console.log(openMessageModal,data.order_number);
    const url = `${apiUrl}/sap_digital_orders/${data.id}/resend_order`;
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify({});

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json.data.resend_status);
        if (json.data.resend_status === "Re-sending") {
          // this.setState({ isResendBtnDisable: true });
          setIsResendBtnDisable(true);
          props.fromChildToParentCallback(true);
        }
      });
  };

  // open msg modal function
  const onCloseMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const onOkMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
    setOpenOrderSendMsgModal(false);
    // openOrderSendMsgModal
  };

  const onOkSendOrderE1Modal = (data) => {
    setOpenModal(false);
    setOpenOrderSendModal(false);
    setOpenOrderSendMsgModal(true);
    // this.setState({
    //   openModal: false,
    //   openOrderSendModal: false,
    //   openOrderSendMsgModal: true,
    // });
    // console.log(this.state.openMessageModal,data.order_number);
    const url = `${apiUrl}sap_digital_orders/create_order`;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify({ order_number: data.order_number });

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        // console.log("json ===>", json.data.resend_status);
        // if (json.data.resend_status === "Re-sending") {
        //   this.setState({
        //     isResendBtnDisable: true,
        //     openOrderSendMsgModal: true,
        //   });
        //   this.props.fromChildToParentCallback(true);
        // }
      });
  };

  /**
   *
   * @returns Payment resend button
   */
  // open modal function
  const onPaymentOpenModal = () => {
    // this.setState({ openPaymentModal: true });
    setOpenPaymentModal(true);
  };

  const onPaymentCloseModal = () => {
    // this.setState({ openPaymentModal: false });\
    setOpenPaymentModal(false);
  };

  const onPaymentOkModal = (data) => {
    console.log("onPaymentOkModal data", data);
    const pathSplit = location.pathname.split("/");
    const orderID = pathSplit[2];
    // this.setState({ openPaymentModal: false, openPaymentMessageModal: true });
    setOpenPaymentModal(false);
    setOpenPaymentMessageModal(true);

    // console.log(openMessageModal,data.order_number);
    const url = `${apiUrl}/payment_status_confirm?order_id=${orderID}`;
    const options = CommonHeaderOption();
    options.method = "GET";
    // options.body = JSON.stringify({});

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json.data);
        // if (json.data.resend_status === "Re-sending") {
        //   this.setState({ isResendBtnDisable: true });
        //   props.fromChildToParentCallback(true);
        // }
      });
  };

  // open msg modal function
  const onPaymentCloseMessageModal = () => {
    // this.setState({ openPaymentMessageModal: false });
    setOpenPaymentMessageModal(false);
  };

  const onPaymentOkMessageModal = () => {
    // this.setState({ openPaymentMessageModal: false });
    setOpenPaymentMessageModal(false);
  };

  const { basePath, resource } = props;
  console.log("record....outside", record);
  const { data } = useGetOne("sap_digital_app_orders", { id: record?.id });

  const { permissions } = usePermissions();
  console.log(" permissions ====>", permissions);
  orderStatus = data && data.customer_order_status;
  isSdoCreated =
    data && data.sap_sdo_for_orders && data.sap_sdo_for_orders.length;
  return (
    <TopToolbar>
      {permissions !== "isManual" &&
        data &&
        data.digital_order_system === "isSapPH" &&
        data.customer_order_status != 0 && (
          <Button
            className="custom-button resend-button mr-send-btn"
            onClick={onPaymentOpenModal}
          //   disabled={
          //     !!isResendBtnDisable ||
          //     data.resend_status === "Re-sending"
          //   }
          >
            <span>Send payment info</span>
          </Button>
        )}
      {permissions !== "isManual" && data && !!openPaymentModal ? (
        <CustomModal
          open={openPaymentModal}
          onCloseModal={onPaymentCloseModal}
          showCancel={true}
          text="Are you sure you want to send the payment information to SAP?"
          onOkModal={(data) => onPaymentOkModal(data)}
        />
      ) : null}
      {permissions !== "isManual" && data && !!openPaymentMessageModal ? (
        <CustomModal
          open={openPaymentMessageModal}
          onCloseModal={onPaymentCloseMessageModal}
          showCancel={false}
          text="Data is successfully accepted"
          onOkModal={onPaymentOkMessageModal}
        />
      ) : null}

      {openOrderSendMsgModal ? (
        <CustomModal
          open={openOrderSendMsgModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Your order is being sent to the system. You can check it's progress in the detail page."
          onOkModal={onOkMessageModal}
        />
      ) : null}

      {permissions !== "isManual" &&
        data &&
        (data.digital_order_system === "isSap" ||
          data.digital_order_system === "isSageAPI" ||
          data.digital_order_system === "isJDE" ||
          data.digital_order_system === "isSapPH" ||
          data.digital_order_system === "isMulesoft") &&
        (data.customer_order_status === "0" ||
          data.resend_status === "Re-send failed - Try again") && (
          <Button
            className="custom-button resend-button mr-send-btn"
            onClick={onOpenModal}
            disabled={
              !!isResendBtnDisable || data.resend_status === "Re-sending"
            }
          >
            <span>Re-send order</span>
          </Button>
        )}
      {permissions !== "isManual" && data && !!openModal ? (
        <CustomModal
          open={openModal}
          onCloseModal={onCloseModal}
          showCancel={true}
          text="Are you sure you want to re-send this order?"
          onOkModal={() => onOkModal(data)}
        />
      ) : null}
      {permissions !== "isManual" && data && !!openMessageModal ? (
        <CustomModal
          open={openMessageModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Your order is being re-sent to the system. You can check it's progress in the detail page."
          onOkModal={onOkMessageModal}
        />
      ) : null}
      {/* <CreateUser data={data} basePath={basePath} resource={resource} /> */}
      <RefreshButton />
      <ListButton basePath={basePath} />
      {permissions === "isManual" && (
        <EditButton resource={basePath} record={data} />
      )}
      {/* )} */}
      {permissions !== "isManual" &&
        data &&
        (data.customer_order_status === "0" ||
          data.resend_status === "Re-send failed - Try again") && (
          <DeleteButton
            basePath={basePath}
            disabled={
              !!isResendBtnDisable || data.resend_status === "Re-sending"
            }
            record={data}
            resource={resource}
          />
        )}
    </TopToolbar>
  );
};

const SdoOrderMaterialsLink = () => {
  const record = useRecordContext();
  console.log("SdoOrderMaterialsLink record", record);
  if (
    record?.sap_materials_for_sdo &&
    record?.sap_materials_for_sdo.length > 0
  ) {
    return (
      <Button
        className="custom-button"
        component={Link}
        to={{
          pathname: "/sap_materials_for_sdos",
          search: `filter={"sap_sdo_for_order_id": ${record?.id}}`,
        }}
      >
        <span>Order Materials</span>
      </Button>
    );
  }
  return <span>No Order Materials</span>;
};

const SdoDisputeDetailsLink = () => {
  const record = useRecordContext();
  console.log("SdoDisputeDetailsLink record", record);
  if (record.sap_sdo_dispute && record.sap_sdo_dispute.length > 0) {
    return (
      <Button
        className="custom-button"
        component={Link}
        to={{
          pathname: "/sap_sdo_dispute/" + record.id + "/show",
          state: { record: { order_sdo_dispute: record } },
        }}
      >
        <span>Delivery Dispute</span>
      </Button>
    );
  }
  return <span>No Delivery Dispute</span>;
};

const DigitalOrderTitle = () => {
  const record = useRecordContext();
  return <span>{record ? `Order No. ${record.order_number} ` : ""}</span>;
};

const MyDatagridRow = ({ id, permissions }) => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  console.log("props........record", record);

  if (RecordId.includes(record.id)) {
    DeliveryNumber += 1;
  } else {
    RecordId.push(record.id);
  }

  return (
    <TableRow key={record.id}>
      {/* {permissions === "isManual" && ( */}
      <TableCell>
        <EditButton record={record} basePath={resource} />
      </TableCell>
      {/* )} */}
      <TableCell>{DeliveryNumber}</TableCell>
      {/* <TableCell>
                {record.logon_order_no}
            </TableCell> */}
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TableCell>{record.shipment_number}</TableCell>
        )}
      {sdoFieldSettings &&
        sdoFieldSettings.load_number &&
        sdoFieldSettings.load_number.enabled && (
          <TableCell>{record.load_number}</TableCell>
        )}
      {permissions === "isSap" && (
        <TableCell>{record.logon_order_no}</TableCell>
      )}
      <TableCell>{record.order_status_description}</TableCell>
      <TableCell>
        {record.loading_date &&
          moment(record.loading_date).format("DD/MM/YYYY, h:MM:SS A")}
      </TableCell>
      <TableCell>{record.truck_plate_no}</TableCell>
      <TableCell>{record.lsd_order_no}</TableCell>
      {permissions === "isSap" && <TableCell>{record.on_hold}</TableCell>}
      {permissions === "isSap" && (
        <TableCell>{record.order_validation_code}</TableCell>
      )}
      {permissions === "isSap" && <TableCell>{record.pod_code}</TableCell>}
      <TableCell>
        {(record.receive_full_order === true && "YES") ||
          (record.receive_full_order === false && "NO")}
      </TableCell>
      <TableCell>
        {record.received_date &&
          moment(record.received_date).format("DD/MM/YYYY, h:MM:SS A")}
      </TableCell>
      <TableCell>
        {record.sap_sdo_dispute &&
          record.sap_sdo_dispute.length > 0 &&
          moment(record.sap_sdo_dispute[0].created_at).format(
            "DD/MM/YYYY, h:MM:SS A"
          )}
      </TableCell>
      <TableCell>
        <SdoOrderMaterialsLink />
      </TableCell>
      <TableCell>
        <SdoDisputeDetailsLink record={record} />
      </TableCell>
    </TableRow>
  );
};

const MyDatagridBody = (props) => {
  console.log("props........", props);
  return (
    <DatagridBody
      {...props}
      row={<MyDatagridRow permissions={props.permissions} />}
    />
  );
};

const MyDatagrid = (props) => {
  DeliveryNumber = 0;
  console.log("props../././.", props);
  return (
    <Datagrid
      {...props}
      body={<MyDatagridBody permissions={props.permissions} />}
    />
  );
};

const PayerField = () => {
  const record = useRecordContext();
  return (
    <div>
      <div className="show-page-label">Payer</div>
      <div className="show-page-value">
        {record.payerDetails && record.payerDetails.payer_name}(
        {record.payerDetails && record.payerDetails.payer_sap_code})
      </div>
    </div>
  );
};

const CustomerOrderStatusField = ({ isChildResendBtnDisable }) => {
  const record = useRecordContext();
  console.log("_______", isChildResendBtnDisable, record);
  if (
    record.resend_status !== null &&
    !isChildResendBtnDisable &&
    record.resend_status === "Re-send failed - Try again"
  ) {
    return (
      <div>
        <div className="show-page-label">Order Status</div>
        <div className="show-page-value">{record.resend_status}</div>
      </div>
    );
  } else if (!!isChildResendBtnDisable) {
    return (
      <div>
        <div className="show-page-label">Order Status</div>
        <div className="show-page-value">Re-sending</div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="show-page-label">Order Status</div>
        <div className="show-page-value">
          {record.customer_order_status_desc}
        </div>
      </div>
    );
  }
};

const DigitalOrdersShow = (props) => {
  const record = useRecordContext();
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  console.log("recorddddddddd", location);
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];

  const [isChildResendBtnDisable, setIsChildResendBtnDisable] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const receiveChildValue = (value) => {
    console.log("Parent received value from child: " + value);
    // this.setState({ isChildResendBtnDisable: JSON.parse(value) });
    setIsChildResendBtnDisable(JSON.parse(value));
  };

  const onCloseMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const onOkMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const showModalForEdit = () => {
    // this.setState({ openMessageModal: true });
    setOpenMessageModal(true);
  };

  const { permissions } = usePermissions();
  const resource = useResourceContext();
  // const record = useRecordContext();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const showLineItemEdit = getLocalStorageKey("show_line_item_edit");
  console.log("sdoFieldSettings", sdoFieldSettings);

  const TruckPlateField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const EditBtnField = () => {
    const record = useRecordContext();
    const resource = useResourceContext();
    console.log("XXXXXXXXXXX", record, resource);
    return (
      <EditButton
        resource={resource}
        to={{
          pathname: `/sap_sdo_for_orders/${record.id}`,
          state: {
            order: record,
          },
        }}
        label="Edit"
      />
    );
  };

  const LsdOrderNoField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const ReceiveFullOrderField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const LoadingDateField = ({ source }) => {
    const record = useRecordContext();
    if (record[source] === null) {
      return <span>{"-"}</span>;
    }

    return <DateField record={record} source={source} />;
  };

  const ReceivedDateField = ({ source }) => {
    const record = useRecordContext();
    if (record[source] === null) {
      return <span>{"-"}</span>;
    }

    return <DateField record={record} source={source} />;
  };

  return (
    <div>
      <Show
        title={<DigitalOrderTitle />}
        actions={
          <ShowActions
            fromChildToParentCallback={receiveChildValue}
            permissions={permissions}
          />
        }
        {...props}
      >
        <TabbedShowLayout className="tab-scroll">
          <Tab label="Order Details" contentClassName="scrollTab">
            {/* <ShowController {...props}>
                {(controllerProps) => (
                  <>
                    <TextField source="mode_of_transport" />
                    <TextField source="vehicle_type" label="Truck Type" />
                  </>
                )}
              </ShowController> */}
            <ShowController {...props}>
              {(controllerProps) => {
                const Mod = controllerProps.record.mode_of_delivery;
                console.log("ModModModModMod", Mod);
                const orderPendingNote =
                  controllerProps.record.sap_order_failed_message;
                return (
                  <ShowView
                    {...props}
                    actions={<></>}
                    {...controllerProps}
                    title=" "
                  >
                    <SimpleShowLayout className="simpleLayoutCustom">
                      <TextField source="order_number" />
                      {/* <TextField label="Order Status" source="customer_order_status_desc" /> */}
                      <CustomerOrderStatusField
                        isChildResendBtnDisable={isChildResendBtnDisable}
                      />
                      <ReferenceField
                        // label="Sold To Name"
                        source="business_id"
                        reference="businesses"
                        link="show"
                        allowEmpty
                      >
                        <TextField source="name" />
                      </ReferenceField>
                      <TextField
                        // label="Ship To Name"
                        source="business_site.name"
                      />
                      {/* <ReferenceField
                          label="Ship To Name"
                          source="sap_business_site_id"
                          reference="sap_business_sites"
                          link="show"
                          allowEmpty
                        >
                          <TextField source="name" />
                        </ReferenceField> */}
                      {permissions === "isSap" && <PayerField />}
                      {/* <ReferenceField label="Contract Number" source="sap_contract_id" reference="sap_contracts" linkType="show" allowEmpty>
                            <TextField  source="contarctDetails.contract_number" />
                        </ReferenceField> */}
                      <TextField
                        label="Contract Number"
                        source="contarctDetails.contract_number"
                      />
                      <CamelCaseField
                        source="mode_of_delivery"
                        // label="Mode of Delivery"
                        addLabel
                      />
                      <ReferenceField
                        // label="User name"
                        source="place_order_user_id"
                        reference="users"
                        link="show"
                        allowEmpty
                      >
                        <TextField source="first_name" />
                      </ReferenceField>
                      {/* <ExpectedDateField
                label="Expected Date"
                source="delivery_date_from"
                addLabel
              /> */}
                      <DateField
                        // label="Requested Delivery Date"
                        source="delivery_date_from"
                      />

                      <TextField
                        // label="Local PO Note"
                        source="customer_ref_number"
                      />
                      {Mod === "self_collect" && (
                        <TextField source="sap_plant.name" label="Plant Name" />
                      )}
                      {Mod === "self_collect" && (
                        <TextField
                          source="truck_number"
                        // label="Truck Number"
                        />
                      )}
                      {Mod === "self_collect" && (
                        <TextField
                          source="driver_details"
                        // label="Driver Details"
                        />
                      )}
                      <TextField source="is_app_order" sortable={false} />
                      {Mod === "delivered" && (
                        <TextField
                          source="delivery_address"
                        // label="Delivery Address"
                        />
                      )}
                      <TextField source="payment_method" />
                      <PaymentAmountField source="payment_amount" addLabel />
                      <TextField source="payment_status" />
                      {orderPendingNote && (
                        <TextField
                          // label="Order Pending Note"
                          source="sap_order_failed_message"
                        />
                      )}
                    </SimpleShowLayout>
                  </ShowView>
                );
              }}
            </ShowController>

            {/* <TextField source="business_site.ship_to_sap_number" label="Ship-To number" /> */}
            {/* <TextField source="order_total_price" label="Total Amount" />
                        <TextField source="order_total_tons" label="Total Tons" /> */}
            {/* {permissions === "isSap" && <TextField source="sales_org" />}
              {permissions === "isSap" && (
                <TextField source="distrib_channel" />
              )}
              {permissions === "isSap" && <TextField source="division" />}
              {permissions === "isSap" && <TextField source="comp_code_cd" />}
              {permissions === "isSap" && (
                <DateField label="Date 1st seen in LR" source="created_at" />
              )}
              {permissions === "isSap" &&
                props.resource !== "sap_digital_app_orders" &&
                getLocalStorageKey("show_all_orders") && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              {permissions === "isSap" &&
                props.resource === "sap_digital_app_orders" && (
                  <BooleanField label="On Hold" source="on_hold" />
                )} */}
          </Tab>
          <Tab label="line Items">
            <ReferenceManyField
              label=""
              sort={{ field: "created_at", order: "DESC" }}
              reference="sap_digital_order_line_items"
              target="sap_digital_order_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                // title="Line Items"
                // {...props}
                filterDefaultValues={{ sap_digital_order_id: businessIdVal }}
                sort={{ field: "created_at", order: "DESC" }}
                exporter={false}
                hasCreate={false}
                actions={false}
              >
                <Datagrid bulkActionButtons={false}>
                  {(showLineItemEdit &&
                    Number(orderStatus) < 3 &&
                    isSdoCreated === 0) ||
                    props.permissions === "isManual" ? (
                    <EditButton />
                  ) : showLineItemEdit ? (
                    <button
                      className="edit-modal-btn"
                      onClick={showModalForEdit}
                    >
                      Edit
                    </button>
                  ) : (
                    ""
                  )}
                  <TextField source="material_no" />
                  <TextField
                    source="product_master.name"
                    label="Product Name"
                  />
                  {/* {
                                    permissions === 'isSageAPI' ?
                                    <MaterialQtyUom label="Quantity" /> :
                                    <NumberField source="quantity" label="Quantity (Tons)" />
                                    
                                }
                                {
                                    permissions !== 'isSageAPI' &&
                                    <NumberField source="quantity_bags" label="Quantity (Bags)" />
                                }
                                {
                                    permissions === 'isSageAPI' ?
                                    <MaterialQtyUom label="Dispatched Quantity" /> :
                                    <NumberField source="dispatched_quantity" label="Dispatched Quantity (Tons)" />
                                }
                                {
                                    permissions !== 'isSageAPI' &&
                                    <NumberField source="dispatched_quantity_bags" label="Dispatched Quantity (Bags)" />
                                } */}
                  <NumberField source="quantity" />
                  {localStorageLocale === 'en-AE' && (
                    <TextField
                      source="truck_details.truck_number"
                      label="Truck"
                    />
                  )}

                  <TextField
                    source="product_master.input_uom_name"
                    label="UOM"
                  />
                  <ConvQtyField source="quantity" label="Quantity Conversion" />
                  <ConvQtyUomField
                    source="conversion_uom_name"
                    label="Quantity Conversion UOM"
                  />
                  <NumberField
                    source="dispatched_quantity"
                    label="Dispatched Quantity"
                  />
                  <TextField
                    source="product_master.input_uom_name"
                    label="Dispatched Quantity UOM"
                  />
                  <ConvQtyField
                    source="dispatched_quantity"
                    label="Dispatched Quantity Conversion"
                  />
                  <ConvQtyUomField
                    source="product_master.input_uom_name"
                    label="Dispatched Quantity Conversion UOM"
                  />
                  <AmountField source="unit_price" label="Unit Price" />
                  <LineItemTotalField label="Total" />
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
          <Tab label="Single Delivery">
            {permissions === "isManual" && <CreateSDOButton />}
            <ReferenceManyField
              label=""
              sort={{ field: "creation_date", order: "ASC" }}
              reference="sap_sdo_for_orders"
              target="sap_digital_order_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                // {...props}
                filterDefaultValues={{ sap_digital_order_id: businessIdVal }}
                sort={{ field: "created_at", order: "DESC" }}
                // bulkActionButtons={false}
                exporter={false}
                hasCreate={false}
                actions={false}
              >
                <Datagrid permissions={permissions} bulkActionButtons={false}>
                  {permissions === "isManual" && <EditBtnField />}
                  {/* <EditButton basePath={resource} label="Edit" /> */}

                  {permissions === "isManual" && <TextField source="edit" />}
                  <TextField label="Delivery Number" source="logon_order_no" />
                  {/* <TextField label="Sales Order Number" source="logon_order_no" sortable={false} /> */}
                  {sdoFieldSettings &&
                    sdoFieldSettings.shipment_number &&
                    sdoFieldSettings.shipment_number.enabled && (
                      <TextField
                        // label="Shipment Number"
                        source="shipment_number"
                        sortable={false}
                      />
                    )}
                  {sdoFieldSettings &&
                    sdoFieldSettings.load_number &&
                    sdoFieldSettings.load_number.enabled && (
                      <TextField
                        // label="Loading Number"
                        source="load_number"
                        sortable={false}
                      />
                    )}
                  {/* {permissions === "isSap" && (
                      <TextField
                        label="Load Number"
                        source="logon_order_no"
                        sortable={false}
                      />
                    )} */}
                  <TextField
                    // label="Status"
                    source="order_status_description"
                    sortable={false}
                  />
                  <LoadingDateField
                    showTime={true}
                    // label="Loading date"
                    source="loading_date"
                    sortable={false}
                  />
                  <TruckPlateField source="truck_plate_no" sortable={false} />
                  <LsdOrderNoField
                    // label="Delivery Note"
                    source="lsd_order_no"
                    sortable={false}
                  />
                  {/* {permissions === "isSap" && (
                      <TextField
                        label="On Hold"
                        source="on_hold"
                        sortable={false}
                      />
                    )}
                    {permissions === "isSap" && (
                      <TextField
                        source="order_validation_code"
                        sortable={false}
                      />
                    )}
                    {permissions === "isSap" && (
                      <TextField
                        label="POD Code"
                        source="pod_code"
                        sortable={false}
                      />
                    )} */}
                  <ReceiveFullOrderField
                    // label="Received"
                    source="receive_full_order"
                    sortable={false}
                  />
                  <ReceivedDateField
                    source="received_date"
                    sortable={false}
                    showTime={true}
                  />
                  <DateField
                    // label="Disputed Time"
                    source="created_at"
                    sortable={false}
                    showTime={true}
                  />
                  <SdoOrderMaterialsLink />
                  <SdoDisputeDetailsLink />
                  {/* <ShowButton /> */}
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        </TabbedShowLayout>
      </Show>
      {openMessageModal && (
        <CustomModal
          open={openMessageModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Yo can not edit line items untill you delete all single deliveries."
          onOkModal={onOkMessageModal}
        />
      )}
    </div>
  );
};

export default DigitalOrdersShow;
